import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlAuthorizationRecord = '/authorizationRecord';

const state = {
    authorizationRecord: {},
    authorizationRecords: []
};

const getters = {
    getAuthorizationRecord: state => {
        return state.authorizationRecord;
    },
    getAuthorizationRecords: state => {
        return state.authorizationRecords;
    }
};

const mutations = {
    setAuthorizationRecord: (state, data) => {
        state.authorizationRecord = data;
    },
    setAuthorizationRecords: (state, data) => {
        state.authorizationRecords = data;
    }
};

const actions = {
     setAuthorizationRecord: async ({commit}, data) => {
        //going backend
        let value = {};

        if(!!!data.id) {
            value  = await AxiosProcessor.post(urlAuthorizationRecord, data);
            commit('setAuthorizationRecord', value);
        }
        else {
            value = await AxiosProcessor.put(urlAuthorizationRecord+'/'+ data.id, data);
            commit('setAuthorizationRecord', data);
        }
    },
    async getAuthorizationRecord ({commit}, data){
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        let authorizationRecord;
        let value = {};

        if (state.authorizationRecords.length > 0) {
            authorizationRecord  = state.authorizationRecords.find(doc => doc.id === id);
        }

        if(authorizationRecord) {
            value = authorizationRecord;
        }
        else {
            let response = await AxiosProcessor.get(urlAuthorizationRecord +'/'+id);

            if(response.Item)
                value = response.Item;
        }

        commit('setAuthorizationRecord', value);
    },
    async getAuthorizationRecordForClientId ({commit}, data) {
        let clientId = data.clientId;
        let authRuleId = data.authRuleId;

        if (!clientId && !authRuleId)
            throw {message: 'empty id. Please provide a valid id value'};

        let authorizationRecord= {};
        let value = {};

        if (state.authorizationRecords.length > 0) {
            authorizationRecord  = state.authorizationRecords.find(doc => doc.clientId === clientId
                && doc.authorizationRuleId == authRuleId);
        }

        if(authorizationRecord.id) {
            value = authorizationRecord;
        }
        else {
            let response = await AxiosProcessor.get(urlAuthorizationRecord +'/client/'+clientId+'?authRuleId='+authRuleId);
            if(!!!!response && response.Items)
                value = response.Items;
        }

        commit('setAuthorizationRecord', value);
    },
    async getAuthorizationRecords ({commit}, data){
        //going backend,
        let value = [];
        let response = await AxiosProcessor.list(urlAuthorizationRecord, data);

        if(!!!!response && response.Items)
            value = response.Items;

        commit('setAuthorizationRecords', value);
    },
    async deleteAuthorizationRecord ({commit}, data){
        //going backend,
        let value = {};
        value = await AxiosProcessor.delete(urlAuthorizationRecord+'/'+data.id);

        commit('setAuthorizationRecord', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}